//import Moment from "moment";

const dataFormatada = (state) => {
    if (!state.cargo || !state.cargo.data) return null;
    return Moment(String(state.cargo.data)).format("DD/MM/YYYY");
}

const getCount = (state) => {
	return state.cargos.length;
}

export default {
    dataFormatada,
	getCount
}